import "./services.css";
import Service from "./Service";
import Section from "../../../common/Section/Section";

// Icons for each service
import responsiveWebAppsIcon from "../../../../assets/img/icons/services/RWA.svg";
import databaseDevIcon from "../../../../assets/img/icons/services/DD.svg";
import microsoftOfficeAppsIcon from "../../../../assets/img/icons/services/MOA.svg";
import cloudAppsIcon from "../../../../assets/img/icons/services/CA.svg";
import technicalDirectionIcon from "../../../../assets/img/icons/services/TD.svg";
import projectMgmtIcon from "../../../../assets/img/icons/services/PM.svg";

// Thumbnail photos for each service.
import tailoredSuiteImage from "../../../../assets/img/other/tailoredSuite.webp";

/**
 * List of service objects that will be rendered on to the document.
 * */
const services = [
    {
        icon: responsiveWebAppsIcon,
        title: "Deliver Your Services with Software",
        subtitle: "Buy more time",
        description: "Working with you to design a system that can deliver your services 24/7 with reduced management from yourself.",
        hoverImage: "https://cdn.pixabay.com/photo/2013/02/06/03/53/golfing-78257_960_720.jpg"
    },
    {
        icon: databaseDevIcon,
        title: "Create a Competitive Edge",
        subtitle: "Enhance your image",
        description: "Designing a razor sharp, tailored software system to deliver your services will give you a strong competitive advantage.",
        hoverImage: tailoredSuiteImage
    },
    {
        icon: microsoftOfficeAppsIcon,
        title: "Increase Your Profits",
        subtitle: "Reduce costs",
        description: "Customising software specifically to your processing and management requirements, can significantly reduce your overheads.",
        hoverImage: "https://www.shutterstock.com/image-photo/beautiful-young-woman-getting-out-260nw-1093764296.jpg"
    },
    {
        icon: cloudAppsIcon,
        title: "Turn Your Creative Ideas Into a Reality",
        subtitle: "Realize your vision",
        description: "Our experience in design and delivery makes it surprisingly fast for us to turn your ideas into a working system.",
        hoverImage: "https://www.shutterstock.com/image-photo/ongoing-auction-session-auctioneer-buyers-260nw-1304957026.jpg"
    },
    {
        icon: technicalDirectionIcon,
        title: "Improve Customer Retention",
        subtitle: "Increase popularity",
        description: "Designing the correct online interface with your clients will keep them happy and reliant on your services for longer.",
        hoverImage: "https://www.shutterstock.com/image-photo/side-view-caucasian-businessman-standing-260nw-1331325713.jpg"
    },
    {
        icon: projectMgmtIcon,
        title: "Eradicate Frustration",
        subtitle: "Create a Happier Work Force",
        description: "Identify and remove inconsistencies in your business by creating organised, uniform management of information with employees and clients.",
        hoverImage: "https://www.shutterstock.com/image-photo/close-male-colleagues-cooperating-coworking-260nw-1209551569.jpg"
    }
]

export default function Services() {
    return (
        /*

        */
        <Section title="What we can do with you" subtitle="We don’t just deliver software on time and within budget. We will work with you to ensure your systems align to all aspects of your business." scrollID="services">
            <div className="services-container limit-width">
                {
                    // Bind service to a Service component.
                    services.map(service => (
                        <Service icon={service.icon} title={service.title} subtitle={service.subtitle} description={service.description} hoverImage={service.hoverImage} key={service.title} />
                    ))
                }
            </div>
        </Section>
    )
}